import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';

const BASE_URL = `https://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/getRestDeInfo`;
const SERVICE_KEY = process.env.REACT_APP_OPEN_API_SERVICE_KEY;

// 특정 공휴일 이름 변경
const EDIT_HOLIDAY_NAME = (holidayName: string) => {
  if (holidayName === '1월1일') return '신정';
  if (holidayName === '대체공휴일(1월1일)') return '대체공휴일(신정)';
  if (holidayName === '기독탄신일') return '성탄절';
  if (holidayName === '대체공휴일(기독탄신일)') return '대체공휴일(성탄절)';
  return holidayName;
};

export const useFetchHolidays = (currentYear: string) => {
  const cachedString = localStorage.getItem(`holidays-${currentYear}`);
  const cachedInitial = cachedString ? (JSON.parse(cachedString) as any[]) : undefined;
  const nextNewYear = { dateKind: '01', dateName: '신정', isHoliday: 'Y', locdate: Number(`${Number(currentYear) + 1}0101`), seq: 1 }; // 캘린더 12월 끝에 1월 1일에 신정 연휴를 채워넣기 위함
  const lunar = ['설날 연휴', '설날', '설날 연휴']; // 설날 및 추석 워딩 설정 '추석, 추석, 추석' 대신 '추석 연휴, 추석, 추석 연휴'로 보여지게 설정
  const chuseok = ['추석 연휴', '추석', '추석 연휴'];

  const fetchHolidaysByYear = async (year: string) => {
    try {
      const data = await fetch(`${BASE_URL}?solYear=${year}&ServiceKey=${SERVICE_KEY}&numOfRows=100&_type=json`);
      const { response } = await data.json();
      const resItems = response?.body?.items?.item ?? [];
      const resHolidays = [...(Array.isArray(resItems) ? resItems : [resItems]), nextNewYear];
      const findLunar = resHolidays.find((item) => item.dateName === '설날');
      const findChuseok = resHolidays.find((item) => item.dateName === '추석');
      const filterHolidays = resHolidays.filter((item) => item.dateName !== '설날' && item.dateName !== '추석');

      const addDays = (locdate: number, days: number) => Number(dayjs(String(locdate), 'YYYYMMDD').add(days, 'day').format('YYYYMMDD'));
      const setLunar = findLunar ? Array.from({ length: 3 }, (_, i) => i).map((el) => ({ dateKind: '01', dateName: lunar[el], isHoliday: 'Y', locdate: addDays(findLunar.locdate, el), seq: 1 })) : [];
      const setChuseok = findChuseok
        ? Array.from({ length: 3 }, (_, i) => i).map((el) => ({ dateKind: '01', dateName: chuseok[el], isHoliday: 'Y', locdate: addDays(findChuseok.locdate, el), seq: 1 }))
        : [];

      const setHolidays = [...filterHolidays, ...setLunar, ...setChuseok].sort((a, b) => a.locdate - b.locdate);

      const formatHolidays = (setHolidays as any[]).map((item, index) => {
        if (setHolidays.length === 0) return null; // 빈 배열일 경우 null 반환

        const stringDate = item.locdate.toString();
        const date = dayjs(stringDate, 'YYYYMMDD');
        const startOfDay = date.startOf('day').add(1, 'second').format('YYYY-MM-DD HH:MM'); // 시작 시간 00:00:01 설정
        const endOfDay = date.endOf('day').format('YYYY-MM-DD HH:MM'); // 종료 시간 23:59:59 설정

        return {
          id: index,
          smName: EDIT_HOLIDAY_NAME(item.dateName),
          sDate: stringDate,
          fDate: stringDate,
          year: Number(stringDate.substring(0, 4)),
          month: Number(stringDate.substring(4, 6)),
          day: Number(stringDate.substring(6, 8)),
          sTime: '0000',
          fTime: '2359',
          alldayYn: 'Y',
          repeatDateList: [{ startDate: startOfDay, endDate: endOfDay }],
          users: [],
          dGubun: '',
          scheduleFList: [],
          scheduleD: { smM: 'N' },
          scheduleSet: { fontColor: 'var(--rose-500)', backColor: 'var(--holiday-bg)', userId: '' },
          smGubun: '4',
          isHolidayEvent: true,
        };
      });
      // localStorage에 데이터 캐싱
      localStorage.setItem(`holidays-${year}`, JSON.stringify(formatHolidays));
      return formatHolidays;
    } catch (error) {
      return [] as any[];
    }
  };

  const {
    data: holidays,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['holidays', currentYear],
    queryFn: () => fetchHolidaysByYear(currentYear),
    retry: 1,
    initialData: cachedInitial ?? [],
    // enabled: !cachedInitial, // localStorage에 값이 없을 때만 쿼리 실행
  });

  return { holidays, isLoading, isError };
};
